import React from 'react';
import { lang } from '@umu/ukit-lang';
import { DISCOUNT_TYPE } from '@umu/umu-types';
import { getDiscount } from 'plan/@planPricingCommon/utils/util';
import { If } from 'common/src/components';

interface IProps {
    amount: number;
    discount: number;
    discount_type?: DISCOUNT_TYPE;
}

import './discountTag.scss';
export const DiscountTag = (props: IProps) => {
    const { amount, discount, discount_type: discountType } = props;
    if (!discountType || discount === 1) {
        return null;
    }
    return (
        <div className="discount-tag">
            {lang('原价')}&nbsp;
            <span className="original-price">{amount}</span>
            <If condition={discountType === DISCOUNT_TYPE.LIMITED_TIME}>
                <span className="discount strength-time-limit">{getDiscount(discount, discountType)}</span>
            </If>
            <If condition={discountType !== DISCOUNT_TYPE.LIMITED_TIME}>
                <span className="discount strength-alway">{getDiscount(discount, discountType)}</span>
            </If>
        </div>
    );
};
